export default __webpack_public_path__ + "static/media/prijimacky.69f6d5cc.svg";